import { Component, OnInit } from '@angular/core';
import { FamilyeventGallaryService } from '../Services/familyevent-gallary.service';
import { FamilyEvents, FamilyEventProperties } from '../Models/common.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { KeyValue } from '@angular/common';



@Component({
  selector: 'app-family-event',
  templateUrl: './family-event.component.html',
    styleUrls: [],
    providers: [FamilyeventGallaryService]
})
export class FamilyEventComponent implements OnInit {
    events: Map<string, FamilyEventProperties[]>;

    constructor(public dataService: FamilyeventGallaryService, private spinner: NgxSpinnerService) {

    }

    ngOnInit(): void {
        this.spinner.show();
        this.dataService.getFamilyEventsbyYear().subscribe((data: FamilyEvents[]) => {
            this.events = new Map(data.map(o => [o.Year, o.Galleries]));
            this.spinner.hide();
        })
    }

    originalOrder = (a: KeyValue<string, FamilyEventProperties[]>, b: KeyValue<string, FamilyEventProperties[]>): number => {
        return 0;
    }
    
}
